/**
 * Calculate HSL Lightness from an RGB color string.
 *
 * HSL Lightness = (max(R,G,B) + min(R,G,B)) / 2
 * This maps directly to the lightness slider designers use in Figma/Sketch.
 *
 * @param rgbColor - An RGB string like "rgb(255, 0, 0)"
 * @returns Lightness as a number between 0 and 1
 */
export function getHslLightness(rgbColor: string): number {
  const match = rgbColor.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
  if (!match) {
    return 0
  }

  const r = Number.parseInt(match[1], 10) / 255
  const g = Number.parseInt(match[2], 10) / 255
  const b = Number.parseInt(match[3], 10) / 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)

  return (max + min) / 2
}
